import { render, staticRenderFns } from "./ProgramServiceLog.vue?vue&type=template&id=5240c070&scoped=true&"
import script from "./ProgramServiceLog.vue?vue&type=script&lang=js&"
export * from "./ProgramServiceLog.vue?vue&type=script&lang=js&"
import style0 from "./ProgramServiceLog.vue?vue&type=style&index=0&id=5240c070&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5240c070",
  null
  
)

export default component.exports